// axios
import axios from 'axios'
import {apiUrl} from './constants/config'

export default axios.create({
  baseURL: apiUrl
  // You can add your headers here
})
